module.exports = __webpack_public_path__ + "img/caro.622c24b2.png";